<template>
  <div>
    <v-autocomplete
      outlined
      v-if="readonly === false"
      dense
      v-model="select"
      :items="Lista"
      item-text="Descripcion_zona"
      item-value="id_zona"
      label="Zona"
      persistent-hint
      return-object
      @change="$emit('input', select.id_zona)"
      hide-details
    ></v-autocomplete>
    <v-text-field
      dense
      outlined
      label="Zona"
      v-if="readonly===true"
      readonly
      filled
      :value="select.Descripcion_zona"
      hide-details
    ></v-text-field>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: {
    value: Number,
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      select: {
        id_zona: 0,
        Descripcion_zona: ""
      }
    };
  },
  computed: {
    ...mapState("zonas", ["Lista"]),
    lista: function() {
      let l = [...this.Lista];
      l.push({
        id_zona: 0,
        Descripcion_zona: " --Seleccione-- "
      });
      return l;
    }
  },
  methods: {
    seleccionar(id) {
      if (id) {
        let pr = this.lista.find(x => x.id_zona == id);
        if (pr) {
          this.select = pr;
        } else {
          this.seleccionar("0");
        }
      }
    }
  },
  async mounted() {
    let id = this.value;
    this.seleccionar(id);
  },
  watch: {
    value: function(newVal, oldVal) {
      this.seleccionar(newVal);
    }
  }
};
</script>

<style>
</style>